import {defineStore} from 'pinia'
import api from '@/services/api'
import {useAppStore} from '@/stores/appStore'
import {useTemplatesStore} from '@/stores/templates'
import {useItemDataStore} from '@/stores/itemData'

export const usePageTemplatesContentAreasStore = defineStore('pageTemplatesContentAreas', {
    state: () => ({
        pageTemplatesContentIds: {},
        pageTemplatesContentAreas: undefined,
    }),
    
    getters: {
        contentAreas: () => (templateHtml) => {
            let contentAreas = []
            
            if (templateHtml) {
                let extendsMatch = templateHtml.match(/\{% extends '(.*)' %}/)
                
                if (extendsMatch) {
                    const title = extendsMatch[1]
                    const templatesStore = useTemplatesStore()
                    const item = templatesStore.items?.find((o) => o.title === title)
                    
                    if (item) {
                        let parentHtml = item.templateHtml
                        
                        const blockRegex = /\{% block\s+([^\s%]+)\s%}(.*?){% endblock(?:\s+\1)?\s%}/gs
                        const blockMatches = [...templateHtml.matchAll(blockRegex)]
                        
                        for (const match of blockMatches) {
                            const blockName = match[1]
                            const replaceContent = match[2]
                            
                            const parentBlockRegex = new RegExp(
                                '\\{% block\\s+' + blockName + '\\s%\\}(.*?)\\{% endblock(?:\\s+' + blockName + ')?\\s%\\}',
                                'gs'
                            )
                            
                            parentHtml = parentHtml.replace(parentBlockRegex, replaceContent)
                        }
                        
                        templateHtml = parentHtml
                    }
                }
                
                const areaRegex = /(?:area_content\(|content\[)['"]([^'"]+)['"]/g
                let areaMatch
                
                while ((areaMatch = areaRegex.exec(templateHtml)) !== null) {
                    if (!contentAreas.includes(areaMatch[1])) {
                        contentAreas.push(areaMatch[1])
                    }
                }
            }
            
            return contentAreas
        },
        
        contentIds: () => (templateHtml) => {
            let contentIds = []
            
            if (templateHtml) {
                const matches = [...templateHtml.matchAll(/content\(([0-9]+)\)/g)]
                if (matches) {
                    matches.forEach((match) => {
                        contentIds.push(parseInt(match[1]))
                    })
                }
            }
            
            return contentIds
        },
    },
    
    actions: {
        async init() {
            if (this.pageTemplatesContentAreas === undefined) {
                const templatesStore = useTemplatesStore()
                await templatesStore.init(false)
                
                const areas = {}
                const pageTemplates = templatesStore.pageTemplates || []
                
                pageTemplates.forEach((o) => {
                    areas[o.id] = this.contentAreas(o.templateHtml)
                })
                
                this.pageTemplatesContentAreas = areas
            }
        },
        
        async getPagesContentAreas(pageId) {
            const itemDataStore = useItemDataStore()
            
            const page = await itemDataStore.get({
                tableName: 'pages',
                id: pageId,
            })
            const templateId = page.templateId
            
            const template = await itemDataStore.get({
                tableName: 'templates_templates',
                id: templateId,
            })
            
            return this.contentAreas(template.templateHtml)
        },
        
        async getPageTemplatesContentIds(templateId) {
            if (templateId) {
                let contentIds = this.pageTemplatesContentIds[templateId]
                if (contentIds) {
                    return contentIds
                }
                
                const appStore = useAppStore()
                const endpoint = appStore.websiteEndpoint || ''
                const response = await api.get(`${endpoint}/controller/page_template_content_ids/${templateId}`)
                contentIds = response?.data?.contentIds
                
                this.pageTemplatesContentIds[templateId] = contentIds
                
                return contentIds
            }
        },
    },
})